module.exports = __webpack_public_path__ + "107cb6fd6be1b32f5afb7da0f9fb71e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/vokabular_inactive.svg
// module id = 68
// module chunks = 0